import axios from "axios";

const baseUrl = process.env.REACT_APP_BACKEND_API;

// สร้าง axios instance ที่มี withCredentials เพื่อส่ง cookies
// const api = axios.create({
//     baseURL: baseUrl,
//     withCredentials: true, // สำคัญ! ต้องมีเพื่อส่ง cookies (CSRF token)
//     headers: {
//           'Content-Type': 'application/json',
//                 'Accept': 'application/json',    }
// });

function getAccessToken(): string | null {
  const accessToken = localStorage.getItem('token') ;
  return accessToken;
}

export async function RecordInvoiceShow(customerWaterId: number) {
  try {
    const accessToken = getAccessToken();
    const response = await axios.get(`${baseUrl}/client/dashboard`, {
      params: {
        customer_water_id: customerWaterId,
      },
        headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${accessToken}`,        },
    });

    return response?.data;
  } catch (error) {
    console.error('❌ RecordInvoiceShow error:', error);
    return null;
  }
}



export async function profileShow(id: number) {
  try {
    const accessToken = getAccessToken();
    const response = await axios.get(`${baseUrl}/client/profile?id=${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${accessToken}`,
      },
    });
    return response?.data?.data;
  } catch (error) {
    console.error('❌ profileShow error:', error);
    return null;
  }
}


export async function postGroup(data: any) {
  try {
    const accessToken = getAccessToken();
    const response = await axios.post(`${baseUrl}/client/customer-group`, data, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${accessToken}`,
      },
    });
    return response?.data;
  } catch (error: any) {
    console.error('❌ addGroup error:', error);
    // Return error response if available
    if (error?.response?.data) {
      return error.response.data;
    }
    return {
      responseStatus: "false",
      responseMessage: "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง"
    };
  }
}




export async function getQrCode(customerWaterId: number) {

  try {
    const accessToken = getAccessToken();
    const response = await axios.get(`${baseUrl}/client/payment/unpaid-invoices`, {
      params: {
        customer_water_id: customerWaterId,
      },
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${accessToken}`,
      },
    });
    return response?.data;
  } catch (error: any) {
    console.error('❌ addGroup error:', error);
    // Return error response if available
    if (error?.response?.data) {
      return error.response.data;
    }
    return {
      responseStatus: "false",
      responseMessage: "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง"
    };
  }
}


export async function refreshInvoice(customerWaterId: number) {
  try {
    const accessToken = getAccessToken();
    const response = await axios.get(`${baseUrl}/client/payment/check-status?customer_water_id=${customerWaterId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${accessToken}`,
      },
    });
    return response?.data;
  } catch (error: any) {
    console.error('❌ refreshInvoice error:', error);
    return null;
  }
  }


  export async function checkMeterNumber(data: any) {
    try {
      const accessToken = getAccessToken();
      const response = await axios.post(`${baseUrl}/client/customer-group/check`, {
        registration_number: data.registrationNumber,
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
      });
      return response?.data;
    } catch (error: any) {
      console.error('❌ getInvoiceDetail error:', error);
      return null;
    }
  }



  export async function deleteUser(id: number) {
    try {
      const accessToken = getAccessToken();
      const response = await axios.delete(`${baseUrl}/client/customer-group/${id}`, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
      });
      return response?.data;
    } catch (error: any) {
      console.error('❌ getMeterNumber error:', error);
      return null;
    }
  }
